import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { enterprise8PoE } from './products/enterprise8PoE.mjs';
import { flex } from './products/flex.mjs';
import { flex10GbE } from './products/flex10GbE.mjs';
import { flex2_5G } from './products/flex2_5G.mjs';
import { flex2_5GPoE } from './products/flex2_5GPoE.mjs';
import { flexMini } from './products/flexMini.mjs';
import { flexMini2_5G } from './products/flexMini2_5G.mjs';
import { lite16PoE } from './products/lite16PoE.mjs';
import { lite8PoE } from './products/lite8PoE.mjs';
import { professional8PoE } from './products/professional8PoE.mjs';
import { proXg8PoE } from './products/proXg8PoE.mjs';
import { switchUltra } from './products/switchUltra.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { ports } from './properties/ports.mjs';
import { downlinkSpeed } from './properties/downlinkSpeed.mjs';
import { uplinkSpeed } from './properties/uplinkSpeed.mjs';
import { poeOutput } from './properties/poeOutput.mjs';
import { poeAvailability } from './properties/poeAvailability.mjs';
import { powerMethod } from './properties/powerMethod.mjs';
import { mounting } from './properties/mounting.mjs';
import { outdoorReady } from './properties/outdoorReady.mjs';
"use strict";
const SwitchingCompact = {
  properties: [dimensions, ports, downlinkSpeed, uplinkSpeed, poeOutput, poeAvailability, powerMethod, mounting, outdoorReady],
  products: [proXg8PoE, flex2_5GPoE, flex2_5G, enterprise8PoE, professional8PoE, lite16PoE, lite8PoE, switchUltra, flex10GbE, flex, flexMini2_5G, flexMini],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true
};
export { SwitchingCompact };
//# sourceMappingURL=SwitchingCompact.mjs.map
